/**
 * Cancel and submit, with batch progress while submitting.
 */

import React from 'react';
import { Button } from 'semantic-ui-react';
import { I18n, Translate } from 'react-redux-i18n';
import { i18nKeys } from '../constants';
import styles from '../AddOrganizationToEvents.module.css';

interface SelectionFooterProps {
  count: number;
  /** Events processed so far, or null when not submitting. */
  progress: number | null;
  onCancel: () => void;
  onSubmit: () => void;
}

const SelectionFooter: React.FC<SelectionFooterProps> = ({
  count,
  progress,
  onCancel,
  onSubmit
}) => {
  const isSubmitting = progress !== null;

  return (
    <div className={styles.footerActions}>
      <Button basic onClick={onCancel} disabled={isSubmitting}>
        <Translate value={i18nKeys.EVENTS.CANCEL} />
      </Button>
      <Button
        primary
        disabled={count === 0 || isSubmitting}
        loading={isSubmitting}
        onClick={onSubmit}
      >
        {isSubmitting
          ? I18n.t(i18nKeys.EVENTS.SUBMITTING, { done: progress, count })
          : I18n.t(i18nKeys.EVENTS.SUBMIT, { count })}
      </Button>
    </div>
  );
};

export default SelectionFooter;
